import { Expose, Type } from 'class-transformer';

export class SopResponseDto {
    @Expose()
    id: string;

    @Expose()
    zenqmsId?: string;

    @Expose()
    sopNumber: string;

    @Expose()
    sopTitle?: string;

    @Expose()
    sopRevision?: string;

    @Expose()
    revisionDate?: string;

    @Expose()
    nextReviewDate?: string;

    @Expose()
    documentUrl?: string;

    @Expose()
    managedBy?: string;

    @Expose()
    context?: string;

    @Expose()
    qncSop?: boolean;

    @Expose()
    lastSyncedAt?: string;

    @Expose()
    syncStatus?: string;

    @Expose()
    warehouseDetailId: string;

    @Expose()
    @Type(() => Date)
    createdAt: string;

    @Expose()
    @Type(() => Date)
    updatedAt: string;
}
